module.exports = __webpack_public_path__ + "static/spotify-podcasts-b319c8d1ca2379ce309539c1b6c9e6d7.svg";